import firebase from 'firebase/compat/app';

// Add the Firebase products that you want to use
import "firebase/compat/auth";
import "firebase/compat/firestore";
import { useAPIClient } from './api_helper';
import { create } from 'lodash';
import { deleteFile } from './fakebackend_helper';

class FirebaseAuthBackend {
  constructor(firebaseConfig) {
    if (firebaseConfig) {
      // Initialize Firebase
      firebase.initializeApp(firebaseConfig);
      firebase.auth().onAuthStateChanged(user => {
        if (user) {
          sessionStorage.setItem("authUser", JSON.stringify(user));
        } else {
          sessionStorage.removeItem("authUser");
        }
      });
    }
  }

  /**
   * Registers the user with given details
   */
  registerUser = (email, password) => {
    return new Promise((resolve, reject) => {
      firebase
        .auth()
        .createUserWithEmailAndPassword(email, password)
        .then(
          user => {
            resolve(firebase.auth().currentUser);
          },
          error => {
            reject(this._handleError(error));
          }
        );
    });
  };

  /**
   * Registers the user with given details
   */
  editProfileAPI = (email, password) => {
    return new Promise((resolve, reject) => {
      firebase
        .auth()
        .createUserWithEmailAndPassword(email, password)
        .then(
          user => {
            resolve(firebase.auth().currentUser);
          },
          error => {
            reject(this._handleError(error));
          }
        );
    });
  };

  /**
   * Login user with given details
   */
  loginUser = (email, password) => {
    return new Promise((resolve, reject) => {
      firebase
        .auth()
        .signInWithEmailAndPassword(email, password)
        .then(
          user => {
            resolve(firebase.auth().currentUser);
          },
          error => {
            reject(this._handleError(error));
          }
        );
    });
  };

  /**
   * forget Password user with given details
   */
  forgetPassword = email => {
    return new Promise((resolve, reject) => {
      firebase
        .auth()
        .sendPasswordResetEmail(email, {
          url:
            window.location.protocol + "//" + window.location.host + "/login",
        })
        .then(() => {
          resolve(true);
        })
        .catch(error => {
          reject(this._handleError(error));
        });
    });
  };

  /**
   * Logout the user
   */
  logout = () => {
    return new Promise((resolve, reject) => {
      firebase
        .auth()
        .signOut()
        .then(() => {
          resolve(true);
        })
        .catch(error => {
          reject(this._handleError(error));
        });
    });
  };

  /**
   * Social Login user with given details
   */
  socialLoginUser = async (type) => {
    let provider;
    if (type === "google") {
        provider = new firebase.auth.GoogleAuthProvider();
      } else if (type === "facebook") {
        provider = new firebase.auth.FacebookAuthProvider();
      }
    try {
      const result = await firebase.auth().signInWithPopup(provider);
      const user = result.user;
      return user;
    } catch (error) {
        throw this._handleError(error);
    }
  };
  
  addNewUserToFirestore = (user) => {
    const collection = firebase.firestore().collection("users");
    const { profile } = user.additionalUserInfo;
    const details = {
      firstName: profile.given_name ? profile.given_name : profile.first_name,
      lastName: profile.family_name ? profile.family_name : profile.last_name,
      fullName: profile.name,
      email: profile.email,
      picture: profile.picture,
      createdDtm: firebase.firestore.FieldValue.serverTimestamp(),
      lastLoginTime: firebase.firestore.FieldValue.serverTimestamp()
    };
    collection.doc(firebase.auth().currentUser.uid).set(details);
    return { user, details };
  };

  setLoggeedInUser = user => {
    sessionStorage.setItem("authUser", JSON.stringify(user));
  };

  /**
   * Returns the authenticated user
   */
  getAuthenticatedUser = () => {
    if (!sessionStorage.getItem("authUser")) return null;
    return JSON.parse(sessionStorage.getItem("authUser"));
  };

  /**
   * Handle the error
   * @param {*} error
   */
  _handleError(error) {
    // var errorCode = error.code;
    var errorMessage = error.message;
    return errorMessage;
  }
}

let _fireBaseBackend = null;

/**
 * Initilize the backend
 * @param {*} config
 */

const APIClient = useAPIClient();
const initFirebaseBackend = config => {
  if (!_fireBaseBackend) {
    _fireBaseBackend = new FirebaseAuthBackend(config);
  }
  return _fireBaseBackend;
};

/**
 * Returns the firebase backend
 */
const getFirebaseBackend = () => {
  return _fireBaseBackend;
};

//video processor API's
const VideoProcessorAPI = {
  processVideo: (async (videoData) => {
    const response = await APIClient.create('/video/process', videoData);
    return response;
  }),
  fetchJobs: (async () => {
    const response = await APIClient.get('/jobs');
    return response;
  }),
  fetchJobDetails: (async (jobId) => {
    const response = await APIClient.get(`/jobs/${jobId}`);
    return response;
  }),
}

//Video Library API's
const VideoLibraryAPI = {
  fetchLibraryData: (async (params) => {
    const response = await APIClient.get('/dam/folders', params);
    return response;
  }),

  createFileFolder: (async (data) => {
    const response = await APIClient.create('/dam/metadata', data);
    return response;
  }),

  deleteFile: (async (data) => {
    const response = await APIClient.delete('/dam/delete', data);
    return response;
  }),
}

//Billing API's
const BillingAPI = {
  fetchBillingInfo: (async (cognito_id) => {
    const response = await APIClient.get(`/billing/details/${cognito_id}`);
    return response;
  }),

  updateBillingInfo: (async (cognito_id, data) => {
    const response = await APIClient.put(`/billing/save/${cognito_id}`, data);
    return response;
  }),

  saveBillingAlert: (async (data) => {
    const response = await APIClient.create('/billing-alert/save', data);
    return response;
  }),
}
  //Order API's
  const OrderAPI = {
    getPlans: (async () => {
      const response = await APIClient.get('/plans');
      return response;
    }),

    fetchInvoice: (async (cognito_id) => {
      const response = await APIClient.get(`/${cognito_id}/invoices`);
      return response;
    }),

    orderTotal: (async (data) => {
      const response = await APIClient.create('/order/total', data);
      return response;
    }),

    orderCreate: (async (data) => {
      const response = await APIClient.create('/order/create', data);
      return response;
    }),

    paymentVerify: (async (data) => {
      const response = await APIClient.create('/payment/verify', data);
      return response;
    }),
  }

export { initFirebaseBackend, getFirebaseBackend, VideoProcessorAPI, VideoLibraryAPI, BillingAPI, OrderAPI };